<ion-app>
  <app-layout>
      <ion-router-outlet></ion-router-outlet>
  </app-layout>
</ion-app>
